import styled from "styled-components";

export const TableHeader = styled.div`
  ${(props) => `
    color: ${props.theme.colors.gray};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;

  div {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .main-info-header {
    align-items: flex-start;
  }
`;

interface IInvoicesContainer {
  gridTemplateColumns?: string;
}
export const InvoicesContainer = styled.div<IInvoicesContainer>`
  box-sizing: border-box;
  padding: 1.5rem 2rem;
  width: 100%;

  input.checkInvoice {
    margin-right: 2rem;
  }

  .attribute {
    margin: 0 !important;
  }

  .clickable-element {
    cursor: pointer;
  }

  .item-container {
    align-items: center;
    display: grid;
    grid-template-columns: ${(props) => props.gridTemplateColumns};
  }

  .titles {
    display: none;
  }

  @media (max-width: 750px) {
    & > div:first-of-type {
      display: none;
    }

    .titles {
      ${(props) => `
        color: ${props.theme.colors.gray};
        font-family: ${props.theme.fontFamilies.primaryFont};
      `}
      display: block;
      font-size: 1.2rem;
      font-weight: 700;
      justify-self: start;
      padding-left: 1rem;
    }

    div {
      padding: 0.2rem 0;
    }

    .item-container {
      grid-template-columns: 1fr;
      row-gap: 0.5rem;
    }

    .attribute {
      align-items: center !important;
      column-gap: 0.5rem;
      display: grid !important;
      grid-template-columns: minmax(9em, 30%) 1fr;
      justify-items: center;

      & > :not(.titles) {
        align-items: center;
        margin-left: 0;
        margin-right: 0;
        text-align: center;
        & > p {
          align-self: center;
        }
      }
    }
  }
`;
